/**
 * What goes between two blocks of an answer's text that a tool call separated.
 *
 * Each step of a tool loop writes its own text, and the steps are joined into
 * one markdown document — with nothing between them, a step ending on
 * "valorisation." and the next opening on "**Voici**" read
 * "valorisation.**Voici**". A blank line makes the second a paragraph of its
 * own, unless one of the two already brings the whitespace.
 *
 * Only for text a tool call separated: a continuation of a cut answer resumes
 * mid-sentence and must stay glued.
 *
 * @param previous The text already written.
 * @param next The text about to be appended.
 * @returns `"\n\n"`, or an empty string when the two already part.
 */
export const textBlockSeparator = (previous: string, next: string): string =>
  previous.length > 0 &&
  next.length > 0 &&
  !/\s$/.test(previous) &&
  !/^\s/.test(next)
    ? "\n\n"
    : "";
